/* Cart drawer cross-sell — fetches Shopify's automatic product recommendations
   for the first item in the cart and adds to cart via Dawn's cart-drawer re-render. */
if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productId && this.dataset.url) this.loadRecommendations();
    }

    loadRecommendations() {
      fetch(`${this.dataset.url}&product_id=${this.dataset.productId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const content = html.querySelector('.cart-recommendations');
          if (!content) {
            this.innerHTML = '';
            return;
          }
          // Exclude same-product-in-another-colour (colour siblings) and items already in cart.
          const exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
          const maxVisible = parseInt(this.dataset.max, 10) || 2;
          let kept = 0;
          content.querySelectorAll('.cart-recommendations__item').forEach((item) => {
            const handle = item.dataset.productHandle;
            if (kept >= maxVisible || exclude.indexOf(handle) !== -1) {
              item.remove();
            } else {
              kept += 1;
            }
          });
          if (kept === 0) {
            this.innerHTML = '';
            return;
          }
          this.innerHTML = content.outerHTML;
          this.bindAddButtons();
        })
        .catch(() => {});
    }

    bindAddButtons() {
      this.querySelectorAll('.cart-recommendations__add').forEach((button) => {
        button.addEventListener('click', () => this.addToCart(button));
      });
    }

    addToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || button.hasAttribute('aria-busy')) return;
      button.setAttribute('aria-busy', 'true');

      const cartDrawer = document.querySelector('cart-drawer');
      const sections =
        cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
          : 'cart-drawer,cart-icon-bubble';

      fetch(this.dataset.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) {
            // error (e.g., sold out) — just unlock the button
            button.removeAttribute('aria-busy');
            return;
          }
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(state);
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => button.removeAttribute('aria-busy'));
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
